import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import DeficiencyDetail from './DeficiencyDetail';
export default function DeficiencyShow({ deficiencyId, deficiencyStatuses, deficiencyResolutionStatuses, tags }) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(DeficiencyDetail, { deficiencyId: deficiencyId, deficiencyStatuses: deficiencyStatuses, deficiencyResolutionStatuses: deficiencyResolutionStatuses, tags: tags })));
}
